import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load communities.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const fetchCommunities = async () => {
  const response = await fetch(`${API_BASE}/api/communities`);
  return handleResponse(response);
};

export const fetchCommunitiesForAdmin = async (token) => {
  const response = await fetch(`${API_BASE}/api/communities/manage`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const fetchCommunityAdmins = async (token) => {
  const response = await fetch(`${API_BASE}/api/communities/admins`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to load community admins.');
};

export const createCommunity = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/communities/manage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create community.');
};

export const createCommunityAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/communities/admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create community admin.');
};

export const deleteCommunity = async (communityId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/${communityId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete community.');
};

export const deleteCommunityAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete community admin.');
};

export const fetchCommunityOfficials = async (communityId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/${communityId}/officials`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to load community officials.');
};


export const archiveCommunity = async (communityId, token) => {
  const response = await fetch(`${API_BASE}/api/super-admin/communities/${communityId}/archive`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to archive community.');
};

export const unarchiveCommunity = async (communityId, token) => {
  const response = await fetch(`${API_BASE}/api/super-admin/communities/${communityId}/unarchive`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to unarchive community.');
};
